<template>
  <section>
    <span class="fs-custom serif price-original" v-if="product.special_price && product.price !== product.final_price">
      {{ product.price * qty | price }}
    </span>
    <span class="h4 serif price-regular" v-else data-testid="productPrice">
      {{ (product.final_price ? product.final_price : product.price) * qty | price }}
    </span>
  </section>
</template>
<script>
export default {
  name: 'Price',
  props: {
    product: {
      type: Object,
      required: true
    },
    qty: {
      type: Number,
      required: true
    }
  }
}
</script>
